import { useQuery } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";

function useGetEquipes(unidadeId?: string) {
  return useQuery(
    [URL.PLANO_OPERACIONAL.OBTER_EQUIPE_DROPDOWN_ID_EXTERNO, unidadeId],
    async () => {
      const { data } = await http.get(URL.PLANO_OPERACIONAL.OBTER_EQUIPE_DROPDOWN_ID_EXTERNO, {
        params: { unidadeId },
      });
      return data;
    },
    {
      enabled: !!unidadeId,
    }
  );
}

export default useGetEquipes;
